import React from 'react';

import AboveTheFoldOnlyServerRender from '../../shared/components/above-the-fold-only-server-render';

import PDPOverview from './pdp-overview';
import Features from './pdp-overview/exclusive-features';
import RichContent from './pdp-overview/pdp-rich-content';
import PDPSpecs from './pdp-specs';
import PDPOffers from './pdp-offers';
import Reviews from './reviews';
import PDPCrossSell from './cross-sell';
import PDPUpSell from './upsell';
import CompatibleProducts from './compatible-products';
import FAQS from './faqs';
import UGC from './ugc';
import useTemplateTheme, { WithTheme } from '../../hooks/useTemplateTheme';

const DEFAULT_LAZY_LOAD_SETTINGS = {
    skip: true,
    robots: true,
};

/*
Default layout configuration for PDP
<AboveTheFoldOnlyServerRender skip={true} robots={true}>
    <PDPOverview />
</AboveTheFoldOnlyServerRender>
<AboveTheFoldOnlyServerRender skip={true} robots={true}>
    <CompatibleProducts />
</AboveTheFoldOnlyServerRender>
<PDPCrossSell />
<RichContent />
<Features />
<PDPSpecs lazyLoadSettings={DEFAULT_LAZY_LOAD_SETTINGS} />
<PDPOffers />
<FAQS lazyLoadSettings={DEFAULT_LAZY_LOAD_SETTINGS} />
<UGC />
<Reviews />
<PDPUpSell />
*/
const renderComponent = ({ key }) => {
    switch (key) {
        case 'overview':
            return (
                <AboveTheFoldOnlyServerRender skip={true} robots={true}>
                    <PDPOverview />
                </AboveTheFoldOnlyServerRender>
            );
        case 'compatibleProducts':
            return (
                <AboveTheFoldOnlyServerRender skip={true} robots={true}>
                    <CompatibleProducts />
                </AboveTheFoldOnlyServerRender>
            );
        case 'crossSell':
            return <PDPCrossSell />;
        case 'features':
            return (
                <>
                    <RichContent />
                    <Features />
                </>
            );
        case 'specs':
            return <PDPSpecs lazyLoadSettings={DEFAULT_LAZY_LOAD_SETTINGS} />;
        case 'offers':
            return <PDPOffers />;
        case 'faq':
            return <FAQS lazyLoadSettings={DEFAULT_LAZY_LOAD_SETTINGS} />;
        case 'ugc':
            return <UGC />;
        case 'reviews':
            return <Reviews />;
        case 'upsell':
            return <PDPUpSell />;
        default:
            return null;
    }
};

/**
 * Render PDP layout based on the layout configuration for the template theme
 */
export default () => {
    const {
        layout = [
            'overview',
            'compatibleProducts',
            'crossSell',
            'features',
            'specs',
            'offers',
            'faq',
            'ugc',
            'reviews',
            'upsell',
        ],
    } = useTemplateTheme(['layout']);
    return <>{layout.map((key, index) => renderComponent({ key, index }))}</>;
};

/**
 * Simple component to conditionally render specs based on the template theme
 * @param {} template
 * @returns
 */
export const SpecsByTemplate = ({ position }) => {
    const { techSpecs } = useTemplateTheme(['techSpecs']);
    const { position: themePosition = 'default' } = techSpecs || {};

    if (themePosition === position) {
        return <PDPSpecs lazyLoadSettings={DEFAULT_LAZY_LOAD_SETTINGS} />;
    }
};
